export const getMenuItemByURL = (items, itemFriendlyURL) => {
    for (const item of items) {
        if (item.friendlyURL === itemFriendlyURL) {
            return item;
        } else if (item.children?.length) {
            const found = getMenuItemByURL(item.children, itemFriendlyURL);

            if (found) {
                return found;
            }
        }
    }
};
